import type { OcrCustomerContext } from './ocr-customer-context';
import { joinCustomerContext } from './join-customer-context';

export function buildCustomerContextItems(
  context: OcrCustomerContext | null,
): readonly { label: string; value: string }[] {
  if (!context) return [];
  return [
    { label: 'Address', value: context.customerAddress ?? '' },
    { label: 'Bill To', value: joinCustomerContext(context.billToName, context.billToAddress) },
    { label: 'Ship To', value: joinCustomerContext(context.shipToName, context.shipToAddress) },
    { label: 'Ship Contact', value: context.shipToContact ?? '' },
    { label: 'Ordered By', value: joinCustomerContext(context.orderedBy, context.orderedByEmail) },
  ].filter((item) => item.value.trim().length > 0);
}
